/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Minimum_WarningInputs */

const en_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least two event groups to merge metadata`)
};

const fr_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez au moins deux groupes d'événements pour fusionner les métadonnées`)
};

const de_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie mindestens zwei Ereignisgruppen aus, um Metadaten zusammenzuführen.`)
};

const it_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona almeno due gruppi di eventi per unire i metadati`)
};

const ru_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите как минимум две группы событий для объединения метаданных.`)
};

const es_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione al menos dos grupos de eventos para fusionar los metadatos.`)
};

const zh_cn2_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择至少两个事件组以合并元数据`)
};

const ja_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータをマージするイベントグループを少なくとも2つ選択してください。`)
};

const hi_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा को मर्ज करने के लिए कम से कम दो इवेंट समूह चुनें`)
};

const pt_pt2_metadata_merge_minimum_warning = /** @type {(inputs: Metadata_Merge_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione pelo menos dois grupos de eventos para mesclar metadados.`)
};

/**
* | output |
* | --- |
* | "Select at least two event groups to merge metadata" |
*
* @param {Metadata_Merge_Minimum_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_minimum_warning = /** @type {((inputs?: Metadata_Merge_Minimum_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Minimum_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_minimum_warning(inputs)
	if (locale === "de") return de_metadata_merge_minimum_warning(inputs)
	if (locale === "it") return it_metadata_merge_minimum_warning(inputs)
	if (locale === "ru") return ru_metadata_merge_minimum_warning(inputs)
	if (locale === "es") return es_metadata_merge_minimum_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_minimum_warning(inputs)
	if (locale === "ja") return ja_metadata_merge_minimum_warning(inputs)
	if (locale === "hi") return hi_metadata_merge_minimum_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_minimum_warning(inputs)
	return en_metadata_merge_minimum_warning(inputs)
});